import { useNavigate } from "react-router";

import styles from "./PeriodSelector.module.css";

function PeriodSelector({ ra, period, setPeriod, setIsLoading }) {
    const navigate = useNavigate();

    function handleClick(semester) {
        const year = period.split('.')[0];
        
        setIsLoading(true);
        setPeriod(`${year}-${semester}`);
        navigate(`/${year}-${semester}/aluno/${ra}`);
    }

    return <div className={styles.container}>
        <div className={styles.switch}>
            <div className={period.split('.')[1] === '1' ? [styles.tab, styles.active].join(" ") : styles.tab} onClick={() => handleClick(1)}>
                1º Semestre
            </div>
            <div className={period.split('.')[1] === '2' ? [styles.tab, styles.active].join(" ") : styles.tab} onClick={() => handleClick(2)}>
                2º Semestre
            </div>
        </div>
    </div>
}

export default PeriodSelector;